import React, { useEffect, useState } from 'react';
import { Container, Table, Row, Col } from 'react-bootstrap';
import classes from './style.module.css'
import League from './League'
import { connect } from "react-redux"
import { HORSE_TABLE_COLUMNS_STATIC, HORSE_TABLE_ALL_STATIC } from '../../constants/Constants'
import { SET_SOCCER_LEAGUES_STATE, SET_SELECTION_STATE } from "../../redux/actions"
import sortIconImage from "../../assets/images/sort_both.png"
import { getRaceSummary, getAllRaceDetails, getRaceDetails } from '../../service/backend-api-service';
import Spinner from "../UI/Spinner"
import { Button, ButtonGroup } from 'react-bootstrap'
import "react-sliding-pane/dist/react-sliding-pane.css"
import RaceSlidingPane from "../RaceSlidingPane"
import VolumeMatched from './League/VolumeMatched';

const LeagueTable = (props) => {
    const [sortOrder, setSortOrder] = useState(false) // true - ascending and false - descending
    const [sortColumn, setSortColumn] = useState(null)
    const [loadingState, setLoadingState] = useState(1)
    const [race, setRace] = useState({})
    const [raceType, setRaceType] = useState(null)
    const [raceSummary, setRaceSummary] = useState(null)

    const staticColumns = []
    for (let value in HORSE_TABLE_COLUMNS_STATIC) staticColumns.push(HORSE_TABLE_COLUMNS_STATIC[value])

    const staticColumnsAll = []
    for (let value in HORSE_TABLE_ALL_STATIC) staticColumnsAll.push(HORSE_TABLE_ALL_STATIC[value])

    const finalColumns = raceType === 'ALL' ? [...staticColumnsAll] : [...staticColumns];



    const sortIconClickedHandler = columnId => {
        setSortColumn(columnId)
        if (sortColumn === columnId) setSortOrder(!sortOrder)
    }

    const tableHeaders = finalColumns.map(column => {
        let sortIcon = null
        const description = column.description
        if (!(column.id == HORSE_TABLE_COLUMNS_STATIC.ROW_NUM.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.FORM.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.BOX.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.HORSE_NAME.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.STAR_RATING.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.JOCKEY.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.TRAINER.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.ODD_DETAILS.id ||
            column.id == HORSE_TABLE_COLUMNS_STATIC.WIN_DETAILS.id))
            sortIcon = <img src={sortIconImage} alt="Sort" onClick={() => sortIconClickedHandler(column.id)} />
        if (column.id === HORSE_TABLE_COLUMNS_STATIC.ODD_DETAILS.id) {
            return (
                <th key={column.id}><ButtonGroup size="sm">
                    <Button style={{ fontSize: "10px", padding: "3px", backgroundColor: "#74BBEF" }} variant="outline-dark"><b>Bk</b></Button>
                    <Button style={{ fontSize: "10px", padding: "3px", backgroundColor: "#F8AAB8" }} variant="outline-dark"><b>Ly</b></Button>
                </ButtonGroup>
                </th>
            );
        } else {
            return (
                <th key={column.id}>{description} {sortIcon}</th>
            );
        }
    })

    useEffect(() => {
        const fetchData = async () => {
            if (race && race != 'undefined') {
                setLoadingState(0)
                let apiData = race.type === 'ALL' ? await getAllRaceDetails(race.date) : await getRaceDetails(race)
                let raceSummary = race.type === 'ALL' ? null : await getRaceSummary(race)
                setRaceSummary(raceSummary);
                props.setSoccerLeaguesState(apiData)
                if (apiData) {
                    setLoadingState(2)
                } else {
                    setLoadingState(1)
                }
            }
        }
        setRaceType(race.type)
        fetchData();

    }, [race])


    useEffect(() => {
        setRace({});
        setLoadingState(1)
        props.setSoccerLeaguesState(null)
    }, [props.selectionState])

    const sortData = (a,b) =>{
        console.log("**********" + sortColumn);
        console.log("**********" + sortOrder);
        if (sortColumn != null) {
            let columnDefinition = finalColumns.find(element => element.id === sortColumn);
            const jsonFieldId = columnDefinition.jsonFieldId;
                return compareObject(a, b, jsonFieldId);
            }
            return 0;
        }


    const compareObject = (a, b, jsonFieldId) => {
        if (a === b) return 0
        if (a === null) return 1
        if (b === null) return -1
        a = a[jsonFieldId]
        b = b[jsonFieldId]
        if (a === null || a === "-") return 1
        if (b === null || b === "-") return -1
        if (typeof a === 'number' && typeof b === 'number') {
            a = parseFloat(a)
            b = parseFloat(b)
        }
        if (sortOrder) return a < b ? -1 : 1;
        else return a < b ? 1 : -1;
    }

    let itemList

    if (race.type === 'ALL') {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.map((item, index) => {
                return <League key={item.runner + index} date={item.raceDay}
                    finalColumns={finalColumns} type="ALL" item={item} index={index} />
            }) : null
    } else {
        itemList = props.soccerLeaguesState ?
            props.soccerLeaguesState.sort(sortData).map((item, index) => {
                return <League key={item.runner + index} date={race.raceDay}
                    finalColumns={finalColumns} item={item} index={index} />
            }) : null;
    }

    const getMarketId = (value) => {
        for (var i = 0; i < value.length; i++) {
            if (value[i].bfMarketId) {
                return value[i].bfMarketId;
            }
        }
        return null;
    }

    const volumeMatched = (race.type != 'ALL' && props.soccerLeaguesState && props.soccerLeaguesState.length > 0 &&
        getMarketId(props.soccerLeaguesState)) ?
        <VolumeMatched marketId={getMarketId(props.soccerLeaguesState)} /> : null

    const header = raceSummary ?
        <>
            <font style={{ fontSize: "1.4em" }}>{raceSummary.title} {' '}{' '}{' '} {volumeMatched}</font>
            <div style={{ display: "none" }} id="fileName">
                {raceSummary.name}_{raceSummary.time}
            </div>
            <div style={{ display: "none" }} id="trackId">
                {race.trackId}
            </div>
            <div style={{ display: "none" }} id="raceTime">
                {race.raceTime}
            </div>
        </>
        : null;

    let contentBody = null

    if (loadingState === 0) {
        contentBody = <Spinner />
    } else if (loadingState === 1) {
        contentBody = <div style={{ textAlign: "center" }}>Please select race</div>
    } else {
        contentBody =
            <>
                <b>{header} </b>
                <Table className="LeagueTable" style={{ fontSize: "10px" }} id="runnerDetails" triped bordered hover size="sm">
                    <thead>
                        <tr>
                            {tableHeaders}
                        </tr>
                    </thead>
                    <tbody>
                        {itemList}
                    </tbody>
                </Table>
            </>
    }


    return (
        <Container fluid className={classes.LeagueTable}>
            <Row noGutters>
                <div style={{ width: "219px", height: "800px", overflowY: "scroll", backgroundColor: "#6c757d" }}>
                    <RaceSlidingPane selectionDate={props.selectionState.selectionDate} raceSelectHandler={setRace} />
                </div>
                <Col style={{ overflow: "scroll", paddingLeft: "1px" }} > {contentBody}</Col>
            </Row>
        </Container>
    )
}


const mapStateToProps = state => {
    return {
        soccerLeaguesState: state.soccerLeaguesState,
        selectionState: state.selectionState
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSoccerLeaguesState: payload =>
            dispatch({ type: SET_SOCCER_LEAGUES_STATE, payload: payload }),
        setSelectionState: payload =>
            dispatch({ type: SET_SELECTION_STATE, payload: payload })
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeagueTable);